export default __webpack_public_path__ + "static/media/warning--length-restriction--g1.883f897f.png";